export function colorize(text: string): string {
    if (typeof text !== "string") return "";

    return text
        .replace(/(.+:\s)/g, '<span style="color: lightyellow">$1</span>')
        .replace(/^(.+? \$\s*.*)$/, line => `<span style="color: limegreen">${line}</span>`)
        .replace(/\b(https?:\/\/[^\s]+)/g, '<a href="$1" target="_blank" style="color: lightblue">$1</a>')
        .replace(/\b([\w-]+\.txt)\b/gi, '<span style="color: lightyellow;">$1</span>')
        .replace(/\b([\w-]+\.pdf)\b/gi, '<a href="/files/$1" target="_blank" style="color: lightblue">$1</a>')
        .replace(/\b([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})\b/g, '<a href="mailto:$1" style="color: lightblue; text-decoration: underline;">$1</a>')
        .replace(/(USAGE: .+)/g, '<span style="color: yellow">$1</span>')
        .replace(/(ERROR: .+)/g, '<span style="color: red">$1</span>')
        .replace(/`(.+)`/g, '<span style="color: lightgreen">$1</span>')
        .replace(/(Terminal-Resume)/g, '<span style="color: lightgreen">$1</span>')
        .replace(/(Cezary924)/g, '<span style="color: palevioletred">$1</span>')
        .replace(/(Cezary Zięba)/g, '<span style="color: palevioletred">$1</span>');
}